import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';
import { getBaseControlClassName } from '../utils/classNameUtils';

const HeaderControl = memo<ControlRendererProps>(({ control }) => {
  const containerClassName = getBaseControlClassName(control, {
    disabled: control.disabled,
  });

  const rawLevel = control.config?.level;
  const parsedLevel =
    typeof rawLevel === 'number'
      ? rawLevel
      : typeof rawLevel === 'string'
        ? parseInt(rawLevel, 10)
        : 2;
  const level = Number.isFinite(parsedLevel) ? Math.min(Math.max(parsedLevel, 1), 6) : 2;

  const Tag = `h${level}` as React.ElementType;
  const alignment = (control.config?.alignment as string) ?? undefined;
  const color = (control.config?.color as string) ?? undefined;
  // ?? so an explicitly cleared content (undefined) falls through to label, but '' stays as ''
  const content = (control.config?.content as string) ?? control.label ?? String(control.defaultValue ?? '');

  return (
    <div className={containerClassName}>
      <Tag
        id={control.id}
        className="control__header"
        style={{ textAlign: alignment as React.CSSProperties['textAlign'], color }}
      >
        {content}
      </Tag>

      {control.helpText && (
        <div className="control__help">{control.helpText}</div>
      )}
    </div>
  );
});

HeaderControl.displayName = 'HeaderControl';

export default HeaderControl;
